export const EVENT_SLOT_TYPE = {
  FLOW: 'flow',
  SESSION: 'session',
} as const;

export type EventSlotType = (typeof EVENT_SLOT_TYPE)[keyof typeof EVENT_SLOT_TYPE];
